import PathStepContainer from "library/show/components/path/list/step/PathStepContainer"
import { DESIGN } from "path/constants"
import StepHeaderDescription from "./StepHeaderDescription"
import "./styles/StepHeader.css"

const StepHeader = ({ step, mode, isEditingStep }) => (
  <div className="StepHeader">
    <PathStepContainer
      item={step}
      isEditing={mode === DESIGN}
      standalone={true}
    />
    {!isEditingStep ? <StepHeaderDescription step={step} /> : undefined}
  </div>
)

StepHeader.displayName = "StepHeader"

export default StepHeader
